<template>
  <div class="static-options">
    <div class="icon-cont">
      <router-link :to="{ name: 'Home' }">
        <div class="static-icon"><font-awesome-icon icon="home" /></div>
      </router-link>
      <router-link :to="{ name: 'Home' }" class="footer-text">Home</router-link>
    </div>

    <div class="icon-cont">
      <router-link :to="{ name: 'Category', params: { categoryId: 1 } }">
        <div class="static-icon"><font-awesome-icon icon="shopping-cart" /></div>
      </router-link>
      <router-link :to="{ name: 'Category', params: { categoryId: 1 } }" class="footer-text">Shop</router-link>
    </div>

    <div class="icon-cont">
      <router-link :to="{ name: 'ProgramMenu' }">
        <div class="static-icon"><font-awesome-icon icon="comments" /></div>
      </router-link>
      <router-link :to="{ name: 'ProgramMenu' }" class="footer-text">Program</router-link>
    </div>

    <div class="icon-cont" v-if="recognitionEnabled">
      <router-link :to="{ name: 'RecognitionFeed' }">
        <div class="static-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
            />
          </svg>
        </div>
      </router-link>

      <router-link
        :to="{ name: 'RecognitionFeed' }"
        class="footer-text"
        active-class="router-link-exact-active"
      >
        Recognition
      </router-link>
    </div>

    <!-- Swag / Bonus Points — only when enabled -->
    <div class="icon-cont" v-if="bonusPointsEnabled">
      <router-link :to="{ name: 'Bonus Points' }">
        <div class="static-icon"><font-awesome-icon icon="gift" /></div>
      </router-link>
      <router-link :to="{ name: 'Bonus Points' }" class="footer-text">{{ bonusPointsMenuItem }}</router-link>
    </div>

    <div class="icon-cont">
      <router-link :to="{ name: 'AccountHistory' }">
        <div class="static-icon"><font-awesome-icon icon="user" /></div>
      </router-link>
      <router-link :to="{ name: 'AccountHistory' }" class="footer-text">Account</router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import RecognitionChallengesService from "@/services/RecognitionChallengesService";

export default {
  computed: {
    ...mapState({
      bonusPointsEnabled:  state => state.company.bonusPointsIsEnabled,
      bonusPointsMenuItem: state => state.company.bonusPointsMenuItem,
      bonusPointsIconClass: state => state.company.bonusPointsIconClass,
      client: (state) => state.user.profile.clientId,
    }),
  },
  data() {
    return {
      recognitionEnabled: false,
    };
  },
  methods: {
    fetchRecognitionStatus() {
      if (this.client) {
        RecognitionChallengesService.getModuleStatus(this.client)
          .then((resp) => {
            this.recognitionEnabled = resp.data.data.isEnabled;
          })
          .catch(() => {
            this.recognitionEnabled = false;
          });
      }
    },
  },
  // Add watcher
  watch: {
    client(val) {
      if (val) this.fetchRecognitionStatus();
    }
  },
  created() {
    this.fetchRecognitionStatus();
  },
};
</script>
<style lang="scss">
  .static-options {
    position: fixed;
    z-index: 1000;
    background-color: white;
    border-top: 1px solid #ebebeb;
    box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.06);
    overflow: hidden;
    height: 10vh;
    width: 100vw;
    bottom: 0;
    font-weight: bold;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    color: black;
  }
  
  .static-icon {
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 5vh;
    width: 5vh;
    transition: background 0.18s, color 0.18s;
  }
  
  .icon-cont {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    /* Active icon — filled background pill */
    a.router-link-exact-active .static-icon {
      background-color: $primary;
      color: #fff;
    }

    /* Active label */
    a.router-link-exact-active.footer-text {
      color: $primary;
    }
  }

  .footer-text {
    color: #888;
    font-size: 0.7rem;
    font-weight: 600;
    margin-top: 2px;
    transition: color 0.18s;
  }
  .icon-cont svg {
    width: 1.2rem;
    height: 1.2rem;
    display: block;
  }
  </style>